// Banner (drawing v2.6, `.banner`; reference section 7): a page-wide message
// under the header, radius 10. Info, warning or error; a bold line, one
// sentence, one action. Only an info banner can be dismissed.

import type { ReactNode } from "react";
import { AlertTriangle, Info, X, XCircle } from "lucide-react";
import { IconButton } from "./IconButton";
import { cx } from "./cx";

export function Banner({ tone = "info", title, children, action, onDismiss, className }: { tone?: "info" | "warn" | "bad"; title?: ReactNode; children: ReactNode; action?: ReactNode; /** Only an info banner may be dismissed. */ onDismiss?: () => void; className?: string }) {
  const Icon = tone === "bad" ? XCircle : tone === "warn" ? AlertTriangle : Info;
  return (
    <div className={cx("pg-banner", `pg-banner--${tone}`, className)} role={tone === "bad" ? "alert" : "status"}>
      <Icon className="pg-ico" aria-hidden />
      <div className="pg-banner__tx">
        {title && <b>{title}</b>}
        {children}
      </div>
      {action}
      {tone === "info" && onDismiss && <IconButton label="Dismiss" icon={<X className="pg-ico pg-ico--s" aria-hidden />} onClick={onDismiss} />}
    </div>
  );
}
